import React from 'react';

const IconlyCurvedBoldFolder = ({ width = 20, height = 20, fill = "#D9D9D9" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 20 20">
    <path
      fill={fill}
      fillRule="evenodd"
      d="M13.99 12.896H5.996a.625.625 0 0 1 0-1.25h7.994a.625.625 0 0 1 0 1.25Zm2.92-6.851c-.915-.985-2.08-.962-3.108-.944-.644.012-1.254.025-1.689-.224-.537-.306-.723-.652-.939-1.055-.238-.445-.508-.949-1.242-1.346-1.355-.73-2.946-.872-5.006-.447-2.036.417-3.352 2.22-3.352 4.596v5.055c0 6.06 3.493 6.529 8.425 6.529 4.774 0 8.425-.48 8.425-6.552 0-1.487 0-3.977-1.515-5.612Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IconlyCurvedBoldFolder;